/** Terms & Privacy — Español. Actualmente sobre todo 1:1; grupos, canales y moderación pueden añadirse después. */
export const legalDocumentsEs = {
  termsFull: `1. Aceptación de estos términos

Al crear una cuenta, iniciar sesión o usar Duvpost (el «Servicio», «nosotros»), aceptas estos Términos de servicio. Si no estás de acuerdo, no uses el Servicio.

2. Qué es Duvpost

Duvpost es una aplicación web de mensajería y comunicación en tiempo real, operada a pequeña escala.

Hoy el producto se centra en chat en tiempo real uno a uno, archivos adjuntos, llamadas de voz y vídeo entre usuarios individuales, salas tipo Meet por enlace, y descubrimiento/perfil (p. ej. People) con correo/contraseña o Google. Las conversaciones de grupo, canales y flujos dedicados de moderación no son funciones obligatorias de la versión actual, pero pueden introducirse más adelante sin un acuerdo aparte contigo; si las añadimos, estos Términos también regirán esas funciones.

Podemos añadir, cambiar o retirar funciones con el tiempo. No todas las funciones descritas están disponibles en tu región, plan o versión de la app en todo momento.

El Servicio utiliza Google Firebase (Authentication, Firestore, Storage, Cloud Functions e infraestructura relacionada) y otros componentes descritos en la Política de privacidad.

3. Elegibilidad

Al menos 16 años o la edad mínima en tu país. Menores solo con consentimiento del tutor. No recopilamos a sabiendas datos de menores por debajo de la edad aplicable.

4. Tu cuenta

Información veraz, credenciales seguras, responsabilidad de la actividad bajo tu cuenta. Si sospechas compromiso, avísanos por los canales publicados.

Para planes de pago (p. ej. «Premium»), las tarifas, ciclos de facturación e impuestos se muestran al comprar. El impago puede degradar o eliminar funciones de pago.

5. Planes, límites de almacenamiento y retención

Podemos ofrecer distintos niveles de cuenta (p. ej. estándar/gratuito y de pago). Los límites — p. ej. tamaño máximo de archivo, almacenamiento total, subidas simultáneas o eliminación automática de adjuntos tras un plazo — pueden variar según el plan y cambiar. Intentaremos avisar con antelación de cambios materiales cuando sea razonable (p. ej. en la app, por correo o términos actualizados), salvo obligación legal en contrario.

En planes limitados, los archivos subidos pueden eliminarse automáticamente tras un plazo que indiquemos o al superar cuotas. Los planes superiores pueden ofrecer límites mayores, retención más larga o menos restricciones; «ilimitado» sigue sujeto a uso razonable y políticas contra abusos.

Eres responsable de tus copias de seguridad de datos importantes. El Servicio actual conserva los mensajes y archivos de chat 14 días desde su creación y luego los elimina automáticamente. No garantizamos almacenamiento ilimitado e indefinido de contenido de usuario.

6. Contenido del usuario

Conservas derechos sobre tu contenido. Nos concedes una licencia limitada, mundial y no exclusiva para alojar, almacenar, reproducir, transmitir y mostrar tu contenido solo en la medida necesaria para operar y asegurar el Servicio, hacer cumplir estos términos y cumplir la ley — chats uno a uno, llamadas, Meet y, cuando existan, grupos, canales y funciones relacionadas.

No reclamamos propiedad sobre tu contenido. El contenido de mensajes puede almacenarse cifrado; detalles en la Política de privacidad. Eres responsable de la legalidad y los derechos de terceros. Cuando existan grupos o canales, allí también aplican la ley y estos términos; podemos publicar reglas adicionales.

7. Uso aceptable

Prohibido, entre otros: uso ilegal, dañino, acosador o discriminatorio; malware/phishing; acceso no autorizado; abuso de APIs; suplantación; violación de PI o privacidad; spam; uso de canales abiertos o descubribles y funciones similares, si y cuando se ofrezcan, para contenido ilegal.

Podemos suspender el acceso o eliminar o restringir contenido cuando la ley o estos términos lo exijan. No tenemos obligación general de supervisar toda la comunicación de usuarios; si introducimos herramientas de denuncia o moderación, su uso no garantiza plazos de respuesta ni resultados concretos.

8. Llamadas e infraestructura de terceros

Voz/vídeo (incl. llamadas de grupo si las añadimos): medios P2P o relay (TURN). Operadores de red y relay procesan según sus políticas. Permisos de navegador/SO los controlas tú.

9. Servicios de terceros

Google/Firebase; pagos con procesadores con sus propios términos. Las vistas previas de enlaces pueden solicitar sitios de terceros.

10. Propiedad intelectual

Marca y software de Duvpost (excepto tu contenido) están protegidos.

11. Exención de garantías

El Servicio se ofrece «tal cual» y «según disponibilidad». En la medida permitida por la ley, renunciamos a todas las garantías, expresas, implícitas o legales, incluidas comerciabilidad, idoneidad para un fin determinado, disfrute tranquilo y no infracción.

No garantizamos funcionamiento ininterrumpido o libre de errores, corrección de defectos, ausencia de componentes dañinos en nuestros servidores ni que los datos nunca se pierdan, corrompan o divulguen. El Servicio no es un archivo de copias de seguridad, no sustituye asesoramiento médico, legal o financiero profesional, no es un servicio de emergencias ni un sistema de registro para obligaciones legales o regulatorias salvo acuerdo escrito explícito.

No somos responsables de la exactitud, legalidad o calidad del contenido enviado por otros usuarios. El uso del Servicio y la confianza en cualquier contenido es bajo tu propio riesgo.

12. Limitación de responsabilidad

En la medida permitida por la ley, nosotros, nuestros proveedores, directivos y personal no seremos responsables de daños indirectos, incidentales, especiales, consecuentes o punitivos, ni de lucro cesante, ingresos, datos, fondo de comercio u oportunidades, aunque se hubiera advertido la posibilidad.

Nuestra responsabilidad agregada por todas las reclamaciones derivadas del Servicio o estos términos se limita al mayor de (a) lo que pagaste por el Servicio en los doce (12) meses anteriores a la reclamación o (b) 50 EUR si no hubo pagos. Estas limitaciones aplican cualquiera que sea la base legal (contrato, agravio incl. negligencia, responsabilidad estricta), salvo donde la ley lo prohíba (p. ej. muerte o lesiones personales por nuestra negligencia, fraude).

Si en tu jurisdicción ciertas limitaciones no son válidas, nuestra responsabilidad se limita al máximo permitido por la ley.

13. Indemnización

Nos indemnizas frente a reclamos, daños, pérdidas y honorarios legales razonables derivados de tu uso, tu contenido o tu incumplimiento, salvo mala conducta intencional nuestra.

14. Terminación

Puedes dejar de usar en cualquier momento; podemos suspender por incumplimiento, riesgo de seguridad, impago o requisitos legales. Sobreviven las disposiciones que por su naturaleza deban sobrevivir (límites de responsabilidad, indemnización, ley aplicable).

15. Cambios

Podemos actualizar estos términos y la fecha «Última actualización». Los cambios materiales pueden requerir aviso o consentimiento adicional según la ley. El uso continuado tras la entrada en vigor implica aceptación salvo que la ley exija lo contrario.

16. Ley aplicable y disputas

Estos términos se rigen por las leyes del país donde el operador del Servicio tiene su domicilio social o establecimiento principal, sin perjuicio de las normas imperativas de protección al consumidor que te correspondan en tu país de residencia habitual.

Si eres consumidor con residencia habitual en el Espacio Económico Europeo, puedes invocar las disposiciones imperativas del derecho de tu país de residencia cuando así lo prevea la ley, y entablar procedimientos contra nosotros ante los tribunales de tu domicilio cuando la ley lo exija. Podemos entablar procedimientos contra ti ante los tribunales de nuestro establecimiento o, donde se permita, en tu país de residencia.

17. Disposiciones varias

Si alguna disposición es inválida, las demás permanecen en vigor. Estos términos, junto con la Política de privacidad y los términos específicos del plan mostrados al comprar, constituyen el acuerdo completo. No puedes ceder tus derechos sin nuestro consentimiento; nosotros podemos ceder en relación con fusión, adquisición o venta de activos. La falta de ejercicio de un derecho no es renuncia. No somos responsables por retrasos o fallos por causas fuera de nuestro control razonable (fuerza mayor).

18. Contacto

Preguntas sobre estos términos: operador según datos publicados en la app (p. ej. About) o en el sitio.

Última actualización: marzo de 2026`,

  privacyFull: `1. Introducción

Esta Política de privacidad describe cómo tratamos los datos personales al usar Duvpost. Complementa los Términos de servicio.

El Servicio opera a pequeña escala; las funciones pueden crecer (grupos, canales, llamadas grupales, planes de pago, moderación). La política describe el tratamiento alineado con el producto desplegado y su evolución razonablemente esperable.

2. Responsable

El operador de tu despliegue de Duvpost, indicado en la app (p. ej. About) o en el dominio. Para solicitudes, usa los contactos publicados.

3. Datos que tratamos

Según el uso: cuenta/autenticación; perfil/descubrimiento (People); mensajes (hoy sobre todo 1:1; hilos de grupo si los añadimos); canales si se ofrecen; adjuntos con límites y retención por plan; llamadas/Meet incl. grupos si existen; pagos/suscripciones; datos técnicos; App Check/reCAPTCHA; almacenamiento local; vistas previas de enlaces. No usamos el contenido del chat para entrenar modelos de IA públicos.

4. Fines y bases legales

Ejecución del contrato; seguridad, cuotas, retención; obligaciones legales; correos transaccionales; pagos. Consentimiento aparte para marketing/cookies no esenciales si se introducen.

5. Encargados del tratamiento

Google Firebase y servicios Google relacionados; lista y documentación actuales: https://firebase.google.com/support/privacy y términos de tratamiento de datos de Google Cloud/Firebase. Posiblemente procesadores de pago, hosting, correo.

6. Transferencias internacionales

Como suele ocurrir con Google/Firebase, p. ej. cláusulas contractuales tipo.

7. Conservación

Los mensajes de chat (cifrado en Firestore) y los adjuntos en Storage se conservan 14 días desde su creación y luego se eliminan automáticamente. Los datos de cuenta, perfil y contactos se conservan mientras la cuenta esté activa y sea necesario. Copias de seguridad/registros limitados. Tras eliminar la cuenta, borrado u anonimización en la medida de lo posible; datos de grupo/canal con otros miembros según lógica del producto.

8. Seguridad

HTTPS, reglas, posible cifrado del lado del cliente, App Check, cabeceras — ver documentación técnica.

9. Violaciones de datos personales

Si tenemos conocimiento de una brecha de seguridad que conlleve destrucción, pérdida, alteración o divulgación no autorizada de datos personales bajo nuestro control, tomaremos medidas razonables para mitigar el daño y, cuando la ley lo exija, notificaremos sin demora indebida a autoridades de control y/o a las personas afectadas.

10. Tus derechos

Según tu ubicación: acceso, rectificación, supresión, limitación, oposición, portabilidad, reclamación ante autoridad.

11. Decisiones automatizadas

No usamos tus datos personales para decisiones basadas únicamente en tratamiento automatizado que produzcan efectos jurídicos o te afecten de forma similar de manera significativa, salvo que notifiquemos lo contrario con base legal.

12. Menores

No por debajo de la edad mínima de los Términos.

13. Cookies

Esenciales para inicio de sesión/sesión; otras solo con aviso y, si aplica, consentimiento.

14. Cambios

Podemos actualizar esta política.

15. Contacto

Solicitudes de privacidad al operador según datos publicados.

Última actualización: marzo de 2026`,
} as const;
